/**
 * design_handoff_auth — split layout, customer proof pane on the right.
 * Created by piotr.pozniak@thebeaverhead.com on 20/08/2018.
 */

import React from "react";
import AuthLayout from "./AuthPages/AuthLayout";
import TestimonialPane, { CompactTestimonial } from "./AuthPages/TestimonialPane";
import EmailSignUpForm from "./RegisterPage/EmailSignUpForm";

const RegisterPage = (props) => {
  return (
    <AuthLayout rightPane={<TestimonialPane />} mobileExtra={<CompactTestimonial />}>
      <EmailSignUpForm />
    </AuthLayout>
  );
};

export default RegisterPage;
